var defaultFragment = "varying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\n\nvoid main(void){\n   gl_FragColor *= texture2D(uSampler, vTextureCoord);\n}";

export { defaultFragment as default };
//# sourceMappingURL=defaultProgram.mjs.map
